import { Breadcrumb } from 'antd'
import { DASHBOARD, NOT_FOUND } from '../../config/Path'
import {
    withRouter,
    RouteComponentProps,
    Link,
    useHistory,
} from 'react-router-dom'
import { Language } from '../../config/Language'
import useBreadCrumbContext from '../../hooks/useBreadCrumbContext'

interface PublicRouteParams extends RouteComponentProps {}

const MyBreadcrumbs = ({ ...props }: PublicRouteParams) => {
    const { getTranslation } = Language()
    const { breadCrumb } = useBreadCrumbContext()
    const history = useHistory()
    const {
        location: { pathname },
    } = props
    let pathnames: any[] = pathname.split('/').filter((x) => x)

    let lastName: any = pathnames[pathnames.length - 1]
    if (!isNaN(lastName)) {
        if (breadCrumb.title) {
            lastName = breadCrumb.title
        } else {
            pathnames.pop()
            lastName = getTranslation(pathnames[pathnames.length - 1])
        }
    } else {
        if (breadCrumb.title) {
            lastName = breadCrumb.title
        }
    }

    if (history.location.pathname === NOT_FOUND) {
    }

    return (
        <>
            {pathnames.length > 1 && history.location.pathname !== NOT_FOUND ? (
                <div className='breadcrumb'>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <Link to={DASHBOARD}>
                                {getTranslation('dashboard')}
                            </Link>
                        </Breadcrumb.Item>
                        {pathnames.length > 1 &&
                            pathnames.map((name, index) => {
                                const routeTo = `/${pathnames
                                    .slice(0, index + 1)
                                    .join('/')}`
                                const nameToShow = getTranslation(name)
                                const isLast = index === pathnames.length - 1
                                return isLast ? (
                                    <Breadcrumb.Item key={nameToShow}>
                                        {nameToShow}
                                    </Breadcrumb.Item>
                                ) : (
                                    <Breadcrumb.Item key={nameToShow}>
                                        <Link to={routeTo}>{nameToShow}</Link>
                                    </Breadcrumb.Item>
                                )
                            })}
                    </Breadcrumb>
                    <div className='breadcrumb-title'>{lastName}</div>
                </div>
            ) : (
                ''
            )}
        </>
    )
}

export default withRouter(MyBreadcrumbs)
